import * as React from 'react';
import {
  type GDSHeadingLevel,
  type GDSSpace,
} from '@leagueplatform/genesis-core';
import { SectionHeader as SectionHeaderComponent } from '@leagueplatform/genesis-core-alpha';
import { WidgetType } from '@leagueplatform/masonry-api';
import { type MasonryEngineNode } from '@leagueplatform/masonry-engine';

export interface SectionHeaderProps {
  heading: string;
  headingLevel?: GDSHeadingLevel;
  paddingTop?: GDSSpace;
  textAction?: React.ReactElement;
}

export type SectionHeaderWSNode = MasonryEngineNode<
  WidgetType.SECTION_HEADER,
  SectionHeaderProps
>;

export const SectionHeader = ({
  heading,
  headingLevel = '2',
  paddingTop = '$one',
  textAction,
}: SectionHeaderProps) => (
  <SectionHeaderComponent
    css={{ marginBlockStart: paddingTop }}
    headingLevel={headingLevel}
    title={heading}
    textAction={textAction}
  />
);
